module.exports = __webpack_public_path__ + "img/geodir-mahudi-testimonial.5b1d7821.png";